module.exports = __webpack_public_path__ + "img/1F1F9-1F1F1.160fc6b9.svg";